// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___K8OFg {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 2px 3.84px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
  margin-right: 36px;
}

.style__text___MLfry {
  font-weight: bold;
   white-space: pre-line;
}

.style__date___oMzNT {
  color: silver;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/VaultNote/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;GAChB,qBAAqB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":[".container {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 12px;\n  box-shadow: 0 2px 3.84px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 20px;\n  margin-right: 36px;\n}\n\n.text {\n  font-weight: bold;\n   white-space: pre-line;\n}\n\n.date {\n  color: silver;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___K8OFg`,
	"text": `style__text___MLfry`,
	"date": `style__date___oMzNT`
};
export default ___CSS_LOADER_EXPORT___;
